<template>
  <div>
    <vs-row vs-type="flex" vs-m="2">
      <invite-user class="m-3" invitationType="Doctor" invitedBy="clinic" />
      <invite-user class="m-3" invitationType="Nurse" invitedBy="clinic" />
    </vs-row>
    <vs-row>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3" vs-sm="3" vs-xs="12">
        <vs-card class="m-2">
          <template v-slot:header>
            <div class="heading">Total Doctors</div>
          </template>
          <h1 class="count">{{doctors}}</h1>
        </vs-card>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3" vs-sm="3" vs-xs="12">
        <vs-card class="m-2">
          <template v-slot:header>
            <div class="heading">Total Nurses</div>
          </template>
          <h1 class="count">{{nurses}}</h1>
        </vs-card>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3" vs-sm="3" vs-xs="12">
        <vs-card class="m-2">
          <template v-slot:header>
            <div class="heading">Total Patients</div>
          </template>
          <h1 class="count">{{patients}}</h1>
        </vs-card>
      </vs-col>
    </vs-row>
  </div>
</template>


<script>
import { mapActions } from 'vuex';
import inviteUser from '../components/others/inviteUser';

export default {
  components: {
    inviteUser,
  },
  data() {
    return {
      doctors: 0,
      nurses: 0,
      patients: 0,
    };
  },
  methods: {
    ...mapActions('clinic', ['getClinicDashboardData']),
    getData() {
      const self = this;
      this.getClinicDashboardData().then(res => {
        self.doctors = res.data.data.doctors;
        self.nurses = res.data.data.nurses;
        self.patients = res.data.data.patients;
      });
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style scoped>
.heading {
  font-size: large;
  font-weight: 600;
  color: #000;
}
.count {
  font-size: x-large;
  font-weight: 700;
  text-align: center;
}
</style>
